<div *ngIf="formGroup" [formGroup]="formGroup">
  <div class="d-flex flex-column gap-1">
    <button type="button" class="no-style-button" (click)="toggleSort()">
      <div
        class="d-flex gap-1 align-items-center px-2"
        [style.justify-content]="justifyColumnName"
        [style.height.rem]="2.25">
        <div class="column-name">{{ columnName }}</div>
        <div class="sort-arrow">
          <img [src]="sortIconSrc$ | async" alt="sort-arrow" i18n-alt />
        </div>
      </div>
    </button>
    <div>
      <ng-container [ngSwitch]="searchType">
        <app-table-header-date-input
          *ngSwitchCase="TableColumnHeaderSearchType.Date"
          [controlId]="controlId"
          [formControlName]="controlId" />
        <app-table-header-text-input
          *ngSwitchCase="TableColumnHeaderSearchType.Text"
          [controlId]="controlId"
          [formControlName]="controlId" />
        <app-table-header-number-input
          *ngSwitchCase="TableColumnHeaderSearchType.Number"
          [controlId]="controlId"
          [formControlName]="controlId" />
        <app-table-header-select-input
          *ngSwitchCase="TableColumnHeaderSearchType.Dropdown"
          [clearable]="true"
          [controlId]="controlId"
          [formControlName]="controlId"
          [dropdowns]="dropdownItems$ | async" />
      </ng-container>
    </div>
  </div>
</div>
